import React, { useEffect, useState } from "react";
import "./style.css";
import BlogPagination from "../../components/blog/blogPagination";
import "react-loading-skeleton/dist/skeleton.css";
import BlogListSkeleton from "./skelton/blogListSkelton";
import { MdError } from "react-icons/md";
import { apiAxios, apiPyAxios } from "../../api/axios";
import { Link } from "react-router-dom";
import { getBlogs } from "../../services/blogServices";
import { getLangIdFromCode } from "../../services/langUtils";

const BlogsPage = ({ language = "en" }) => {
  const [blogData, setBlogData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [errorMsg, setErrorMsg] = useState(false);
  const [emailSubscribed, setEmailSubscribed] = useState(false);

  const langId = getLangIdFromCode(language);

  const validateEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };

  const fetchBlogsData = async () => {
    setLoading(true);
    try {
      // let result = await apiAxios.get("blogs/blog_listing?language_id=1");
      // setBlogData(result.data.data);
      const blogs = await getBlogs({ langId });
      setBlogData(blogs);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    fetchBlogsData();
  }, []);

  const handleSubscription = async () => {
    const check = validateEmail(email);

    if (check) {
      setErrorMsg(false);
      try {
        const response = await apiPyAxios.post("newsletter/", { email });
        setEmail("");
        setEmailSubscribed(true);
        console.log(response.data);
      } catch (err) {
        console.log("err", err);
      }
    } else {
      setEmail("");
      setErrorMsg(true);
    }
  };

  return (
    <>
      <div
        className="inner-pages-head"
        style={{ backgroundImage: `url('images/about-header-bg.jpg')` }}
      >
        <div className="container">
          <div className="title_and_breadcrumbs">
            <h1>Newsletter</h1>
            <ul>
              <li>
                <Link to="/">Home</Link>
              </li>
              <span></span>
              <li>Newsletter</li>
            </ul>
          </div>
          <div className="banner-logo">
            <img src="images/mahabharat-logo.svg" alt="" />
          </div>
        </div>
      </div>

      <div className="container">
        <div
          className="email-subs"
          style={{ backgroundImage: "url(/images/Visitor-news.png)" }}
        >
          {emailSubscribed ? (
            <div>
              <div className="subscribed">
                <img src="images/right-shape.png" alt="" />
                <p>
                  Thank you for joining us. We're excited to embark on this
                  journey together!
                </p>
              </div>
            </div>
          ) : (
            <div className="container">
              <h1>Subscribe to our Newsletter</h1>
              <div className="email-wrapper-main">
                <input
                  type="text"
                  placeholder="Enter email"
                  class="enter-email-wrapper"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <button
                  className="subscribe-wrapper"
                  onClick={handleSubscription}
                >
                  SUBSCRIBE
                </button>
              </div>
              {errorMsg && (
                <p className="error-msg">
                  <MdError />
                  {"Please enter valid email"}
                </p>
              )}
            </div>
          )}
        </div>
      </div>

      {loading ? (
        <BlogListSkeleton count={3} />
      ) : (
        blogData.length > 0 && <BlogPagination data={blogData} />
      )}
    </>
  );
};

export default BlogsPage;
